import React from 'react'
import "./whatsAppChatBtn.css"
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'

function WhatsAppChatBtn() {
  return (
    <>
        <Link target='_blank' to={process.env.REACT_APP_WHATSAPP_CHAT}>
                <Button className='wa-tBtn btn' >
                <WhatsAppIcon /> 
                    <span className='no-line-break text'>
                    
                    Help?
                    </span>
            </Button>
                </Link>
    </>
  )
}

export default WhatsAppChatBtn